module.exports = __webpack_public_path__ + "static/img/2.a112c79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/2.jpg
// module id = Zp3M
// module chunks = 1